import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5488c9cb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row align-items-center mb-4" }
const _hoisted_2 = {
  key: 0,
  class: "position-buttons text-primary p-2 mr-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars panel-drag-handle" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_5 = { class: "m-0 flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_PropertyFolderEditor = _resolveComponent("PropertyFolderEditor", true)!
  const _component_Draggable = _resolveComponent("Draggable")!
  const _component_Container = _resolveComponent("Container")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    id: _ctx.id,
    class: "flat border p-4"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("i", {
                class: "pi pi-caret-up",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('move-up'))),
                style: _normalizeStyle({ opacity: _ctx.canMoveUp ? '1' : '0' })
              }, null, 4),
              _hoisted_3,
              _createElementVNode("i", {
                class: "pi pi-caret-down",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('move-down'))),
                style: _normalizeStyle({ opacity: _ctx.canMoveDown ? '1' : '0' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.folder)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.folder.name), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "mr-2",
              icon: "pi pi-plus",
              label: _ctx.i18n.$gettext('Ordner'),
              onClick: _ctx.openNewPanelDialog
            }, null, 8, ["label", "onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              class: "mr-2",
              icon: "pi pi-pencil",
              onClick: _ctx.openFolderEditDialog
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 4,
              icon: "pi pi-trash",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove')))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Container, {
        orientation: "vertical",
        "group-name": "Folders",
        "drag-handle-selector": ".field-drag-handle,.panel-drag-handle",
        "lock-axis": "y",
        "drop-placeholder": { className:
                                 `drop-area`,
                               animationDuration: '200',
                               showOnTop: true },
        "drag-class": "shadow bg-color-lightgray\n            transition duration-100 ease-in\n            transform rotate-3 scale-110",
        "drop-class": "transition duration-100\n            ease-in z-50 transform\n            -rotate-2 scale-90",
        "get-child-payload": index => (_ctx.folder?.children || [])[index],
        onDrop: _cache[3] || (_cache[3] = (e) => _ctx.onFieldDrop((_ctx.folder?.children || []), e))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.folder?.children || []), (f, j) => {
            return (_openBlock(), _createBlock(_component_Draggable, { class: "mt-2" }, {
              default: _withCtx(() => [
                _createVNode(_component_PropertyFolderEditor, {
                  folder: f,
                  disabled: _ctx.disabled,
                  "can-move-up": j > 0,
                  "can-move-down": j < (_ctx.folder?.children || []).length - 1,
                  onRemove: ($event: any) => (_ctx.folder?.children?.splice(j, 1)),
                  onMoveUp: ($event: any) => (_ctx.folder?.children?.splice(Math.max(j - 1, 0), 0, _ctx.folder?.children?.splice(j, 1)[0])),
                  onMoveDown: ($event: any) => (_ctx.folder?.children?.splice(Math.min(j + 1, _ctx.folder?.children?.length - 1), 0, _ctx.folder?.children?.splice(j, 1)[0]))
                }, null, 8, ["folder", "disabled", "can-move-up", "can-move-down", "onRemove", "onMoveUp", "onMoveDown"])
              ]),
              _: 2
            }, 1024))
          }), 256))
        ]),
        _: 1
      }, 8, ["get-child-payload"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Ordner hinzufügen'),
        visible: _ctx.showNewFolderDialog,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showNewFolderDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.newFolderName,
            onClick: _ctx.addOrSaveFolder
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.newFolderName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newFolderName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Ordner-Name'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"]),
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Ordner bearbeiten'),
        visible: _ctx.showEditFolderDialog,
        "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.showEditFolderDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.editedFolderName,
            onClick: _cache[7] || (_cache[7] = ($event: any) => {_ctx.folder.name = _ctx.editedFolderName; _ctx.resetDialogues()})
          }, null, 8, ["label", "disabled"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedFolderName,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editedFolderName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Ordner-Name'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"])
    ]),
    _: 1
  }, 8, ["id"]))
}